import { SelectionInfo } from '../../event-details-common/event-details-common.models';

export class NavState {
    expandedSports: Set<number>;
    collapsedLeagues: Set<number>;
    sportsWithCollapsedMarkets: Set<number>;

    constructor(
        public selection: SelectionInfo | undefined,
        expandedSports: number[],
        collapsedLeagues: number[],
        sportsWithCollapsedMarkets: number[],
    ) {
        this.expandedSports = new Set(expandedSports || []);
        this.collapsedLeagues = new Set(collapsedLeagues || []);
        this.sportsWithCollapsedMarkets = new Set(sportsWithCollapsedMarkets || []);
    }

    isSportExpanded(sportId: number): boolean {
        return this.expandedSports.has(sportId);
    }

    isLeagueCollapsed(leagueId: number): boolean {
        return this.collapsedLeagues.has(leagueId);
    }

    areMarketsCollapsed(sportId: number): boolean {
        return this.sportsWithCollapsedMarkets.has(sportId);
    }

    isEmpty(): boolean {
        return this.expandedSports.size === 0 && this.collapsedLeagues.size === 0 && this.sportsWithCollapsedMarkets.size === 0;
    }

    toggleSport(sportId: number): void {
        if (this.expandedSports.has(sportId)) {
            this.expandedSports.delete(sportId);
        } else {
            this.expandedSports.add(sportId);
        }
    }

    toggleLeague(leagueId: number): void {
        if (this.collapsedLeagues.has(leagueId)) {
            this.collapsedLeagues.delete(leagueId);
        } else {
            this.collapsedLeagues.add(leagueId);
        }
    }

    toggleMarkets(sportId: number): void {
        if (this.sportsWithCollapsedMarkets.has(sportId)) {
            this.sportsWithCollapsedMarkets.delete(sportId);
        } else {
            this.sportsWithCollapsedMarkets.add(sportId);
        }
    }
}
